module.exports = __webpack_public_path__ + "8cda028486e3d103638d9a87606cfcfd.jpg";